module.exports = __webpack_public_path__ + "public/img/sp-dialog.40a748dd.png";